@for (transaction of transactions; track transaction) {
<div class="sub-content">
  <div class="content-item">
    <h4>الفاحص</h4>
    <p>{{ transaction.inspector }}</p>
  </div>

  <div class="content-item">
    <h4>مصدر الفاتورة</h4>
    <p>{{ transaction.created_by }}</p>
  </div>

  <div class="content-item">
    <h4>سبب المعاملة</h4>
    <p>{{ transaction.reason }}</p>
  </div>

  <div class="content-item">
    <h4>تاريخ المعاملة</h4>
    <p>{{ transaction.created_at }}</p>
  </div>

  <div class="content-item">
    <h4>المبلغ</h4>
    <p>{{ transaction.amount }}</p>
  </div>

  @if(transaction.notes?.length > 0) {
  <div class="content-item">
    <h4>ملاحظات</h4>
    <p>{{ transaction.notes }}</p>
  </div>
  }
</div>
}
